// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_Cu4","cls2":"ToolsMenu-cls2_jGZ ToolsMenu-cls1_Cu4"};